import { Pipe, PipeTransform } from '@angular/core';
import {
  SourceRow,
  ValueSource,
  computedSource,
  subsectorSource,
  valueSource,
} from '@app/model';

/**
 * The source of a field of a row for `app-source-badge`:
 * `row | valueSource: 'city'`, `row | valueSource: 'count' : 'employee_details'`;
 * the field `@computed` marks a value Hunter computes, `@subsector` the
 * origin of a subsector row.
 */
@Pipe({ name: 'valueSource', standalone: false })
export class ValueSourcePipe implements PipeTransform {
  transform(
    row: SourceRow | null | undefined,
    field: string,
    table = 'companies'
  ): ValueSource {
    if (field === '@computed') {
      return computedSource(row);
    }
    if (field === '@subsector') {
      return subsectorSource(row);
    }
    return valueSource(row, field, table);
  }
}
